import { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {InterpretationButton} from 'views/components/UI/BluesiteTable/Actions/GridActions'
import { Container } from './styled'
import { MainLayout } from 'views/layouts'
import BluesiteTableComponent from 'views/components/UI/BluesiteTable'
import getAllUninterpretedBetesas from 'services/common/betesa/getBetesaUninterpreted'
import { ACTIONS, HEADER, SEARCH_LABEL } from './constants'
import ModalLoader from 'views/components/UI/ModalLoader/modal-loader'

type UninterpretedBetesas = {
    user_name: string
    company_name: string
    betesa_result_id: number
}

const BetesaInterpretations: FC = () => {
    const { token } = useSelector((state: any) => state.user)
    const [betesas, setBetesas] = useState<UninterpretedBetesas[] | []>([])
    const [skip, setSkip] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [searchParam, setSearchParam] = useState('')

  const limit = 7

  useEffect(() => {
    if (searchParam.length !== 0) return

    setIsLoading(true)
    getAllUninterpretedBetesas(token, skip, 0, searchParam).then((res) => {
      setBetesas(res.betesasWithPreviousInterpretation)
      setTotalPages(res.total_pages_with_previous_interpretation)
      setIsLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, skip, searchParam])

const handleSearch = (search: string) => {
    setSearchParam(search)
    if (search.length === 0) return

    getAllUninterpretedBetesas(token, skip, 0, search).then((res) => {
      setBetesas(res.betesasWithPreviousInterpretation)
      setTotalPages(res.total_pages_with_previous_interpretation)
    })
  }

  const handlePagination = (page: number) => {
    setSkip((page - 1) * limit)
  }

  const currentPage = Math.floor(skip / limit) + 1

  if (isLoading) {
    return <ModalLoader isLoading={isLoading} />
  }

return (
    <MainLayout>
        <Container>
            <div
                style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginBottom: 35,
                marginTop: 50,
                alignItems: 'baseline',
            }}
            >
            <h2 style={{ fontSize: 32 }}>Reinterpretación de pruebas betesa</h2>
            </div>
            <BluesiteTableComponent
                ActionComponent={InterpretationButton}
                data={betesas}
                headers={HEADER}
                actions={ACTIONS}
                searchBar={true}
                searchLabel={SEARCH_LABEL}
                                currentPage={currentPage}
                handlePagination={handlePagination}
                totalPages={totalPages}
                fetchSearchData={handleSearch}
                onSearch={(e) => handleSearch(e)}
            />
        </Container>
    </MainLayout>
  )
}

export default BetesaInterpretations
